import { __generator } from "tslib";
import { put, call, all, takeEvery, select } from 'redux-saga/effects';
import { toggleFeedbackPage, openNotificationsDropdown } from './actions';
import { PureBiData } from '@wix/da-bi/pkg/events';
import { exitDuperbrowse, openDuperbrowse, } from '../../Duperbrowse/redux/actionCreators';
import { FEEDBACK_PAGE_DUPERBROWSE_ITEMID, FEEDBACK_PAGE_DUPERBROWSE_STREAMID, } from '../../Duperbrowse/redux/constants';
import { getIsFeedbackPageOpen } from './selectors';
import { logBiEvent } from '../../biLogger/redux/saga';
function handleOpenNotificationDropdown() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: 
            // not using logPageView here because this is a fake pageview event and we
            // should avoid the side effects running
            return [4 /*yield*/, call(logBiEvent, PureBiData({
                    evid: 99,
                    view: 'notifications',
                    component: 'header',
                }))];
            case 1:
                // not using logPageView here because this is a fake pageview event and we
                // should avoid the side effects running
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function handleToggleFeedbackPage() {
    var isOpen;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getIsFeedbackPageOpen)];
            case 1:
                isOpen = _a.sent();
                if (!isOpen) return [3 /*break*/, 3];
                return [4 /*yield*/, put(exitDuperbrowse())];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, put(openDuperbrowse(FEEDBACK_PAGE_DUPERBROWSE_ITEMID, {
                    streamId: FEEDBACK_PAGE_DUPERBROWSE_STREAMID,
                    items: [FEEDBACK_PAGE_DUPERBROWSE_ITEMID],
                }))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(openNotificationsDropdown, handleOpenNotificationDropdown),
                    takeEvery(toggleFeedbackPage, handleToggleFeedbackPage),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map